import Add from '@mui/icons-material/Add'
import ExpandMore from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Stack,
  Typography,
} from '@mui/material'
import type { TemplateHint } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { addTemplateHint } from 'src/state/ducks/templates/templateHints/actions'
import type { RootState } from 'src/state/store'
import HintTable from './HintTable'

const HintRow: FC = () => {
  const templateHints = useSelector(
    (state: RootState) => state.templatesState.templateHints.templateHints,
    shallowEqual,
  )
  const templateHintErrorMessage = useSelector(
    (state: RootState) =>
      state.templatesState.templateHints.templateHintErrorMessage,
    shallowEqual,
  )

  const dispatch = useDispatch()

  return (
    <Stack sx={{ mt: 2, mx: 2 }}>
      <Accordion
        defaultExpanded
        disableGutters
        elevation={0}
        data-testid="hint-table"
      >
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography>ヒントを追加</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ px: 0 }}>
          <HintTableWithError
            templateHints={templateHints}
            errMsg={templateHintErrorMessage}
          />
          <Button
            variant="text"
            startIcon={<Add />}
            onClick={() => dispatch(addTemplateHint())}
            sx={{ mx: 2, mt: 1 }}
            data-testid="add-hint-button"
          >
            追加
          </Button>
        </AccordionDetails>
      </Accordion>
    </Stack>
  )
}

const HintTableWithError: FC<{
  templateHints: TemplateHint[]
  errMsg: string
}> = ({ templateHints, errMsg }) => {
  if (templateHints.length === 0) {
    return null
  }

  return (
    <>
      <HintTable />
      {errMsg !== '' && (
        <Typography
          color="error"
          fontWeight="bold"
          id="error-message"
          sx={{ mx: 2 }}
        >
          {errMsg}
        </Typography>
      )}
    </>
  )
}

export default HintRow
